/* @flow */
// $FlowIgnore
import { combineReducers } from 'redux';

import auth from './auth';
import list from './list';
import details from './details';
import links from './links';
import relatedEntities from './relatedEntities';
import entityDefinitions from './entityDefinitions';
import message from './message';
import tooltip from './tooltip';
import projects from './projects';
import reports from './reports';
import quicksearch from './quicksearch';
import modal from './modal';
import sidenav from './sidenav';
import workflow from './workflow';
import widgets from './widgets';
import versionInfo from './versionInfo';
import uploadTransactions from './uploadTransactions';
import notifications from './notifications';
import qcReports from './qcReports'

export default combineReducers({
  auth,
  list,
  details,
  links,
  relatedEntities,
  entityDefinitions,
  message,
  tooltip,
  projects,
  reports,
  quicksearch,
  modal,
  sidenav,
  workflow,
  widgets,
  versionInfo,
  uploadTransactions,
  notifications,
  qcReports
});
